import _ from 'lodash';
import React from 'react';
import { wrapDisplayName } from 'recompose';
import { withClient } from '@deerplusofficial/pos-hoc';
import { getResult, createCancelToken } from '@deerplusofficial/pos-helper';

const timeFormat = 'YYYY-MM-DD HH:mm';

export const LIMIT = 5;

export default () => Component =>
  withClient()(
    class extends React.Component {
      static displayName = wrapDisplayName(Component, 'WithQueryOrders');

      state = {
        ordersCount: 0,
        orders: [],
      };

      componentWillUnmount() {
        !_.isUndefined(this.cancelFetch) && this.cancelFetch();
      }

      onFetch = async ({ startDate, endDate, orderNumber, page = 1 }) => {
        const {
          channelId,
          client: { POSApi },
        } = this.props;

        const params = {
          limit: LIMIT,
          offset: (page - 1) * LIMIT,
          channel_id: channelId,
        };
        const keywords = orderNumber
          ? { order_no: orderNumber }
          : {
              sale_start_time: startDate
                .clone()
                .utc()
                .format(timeFormat),
              sale_end_time: endDate
                .clone()
                .utc()
                .format(timeFormat),
            };

        const {
          orders,
          meta: { total: ordersCount },
        } = getResult(
          await POSApi.get(`/orders`, {
            params: { ...params, ...keywords },
            cancelToken: createCancelToken(this.cancelFetch),
          })
        );

        this.setState({ orders, ordersCount });
      };

      render() {
        return (
          <Component
            onQueryOrders={this.onFetch}
            {...this.state}
            {...this.props}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/model/Queries/withQueryOrders.js